import qs from 'qs';
import { AxiosCharts } from '../config';
import { ChartsParamsType, UpdateParamsType } from 'components/Charts universal/types';

export type DashboardChartParams = Omit<ChartsParamsType, 'Sistemas'> & {
  Sistemas?: number[];
  status?: number[];
};

const BASE = '/api/v1/DashBoard';

const serialize = (params: unknown) => qs.stringify(params, { arrayFormat: 'repeat' });

const DashboardChartsService = {
  getOcorrenciasPorSistema: (params: DashboardChartParams) =>
    AxiosCharts.get(`${BASE}/ocorrencias-por-sistema`, { params, paramsSerializer: serialize }),

  getOcorrenciasPorPrioridade: (params: DashboardChartParams) =>
    AxiosCharts.get(`${BASE}/ocorrencias-por-prioridade-por-periodo`, { params, paramsSerializer: serialize }),

  getQuantidadeOcorrenciasPorPeriodo: (params: DashboardChartParams) =>
    AxiosCharts.get(`${BASE}/quantidade-ocorrencias-por-periodo`, { params, paramsSerializer: serialize }),

  getAtividadesPorStatusPorPeriodo: (params: DashboardChartParams) =>
    AxiosCharts.get(`${BASE}/atividades-por-status-por-periodo`, { params, paramsSerializer: serialize }),

  getEntradaSaidaOcorrenciasPorPeriodo: (params: DashboardChartParams) =>
    AxiosCharts.get(`${BASE}/entrada-saida-ocorrencias-por-periodo`, { params, paramsSerializer: serialize }),

  getOcorrenciasPorStatusCorrecaoSemana: (params: DashboardChartParams) =>
    AxiosCharts.get(`${BASE}/quantidade-ocorrencias-por-status-correcao-semana`, {
      params,
      paramsSerializer: serialize,
    }),

  getAnaliseFalhasSDai: (params: DashboardChartParams) =>
    AxiosCharts.get(`${BASE}/analise-falhas-sdai`, { params, paramsSerializer: serialize }),

  getDisponibilidadePorSistemaPorPeriodo: (params: DashboardChartParams) =>
    AxiosCharts.get(`${BASE}/disponibilidade-por-sistema-por-periodo`, { params, paramsSerializer: serialize }),

  getHorasPreventivaseCorretivasPorPeriodo: (params: DashboardChartParams) =>
    AxiosCharts.get(`${BASE}/horas-preventivas-corretivas-por-periodo`, { params, paramsSerializer: serialize }),

  getHorasPorPeriodoPorSistema: (params: DashboardChartParams) =>
    AxiosCharts.get(`${BASE}/horas-por-periodo-por-sistema`, { params, paramsSerializer: serialize }),

  getHorasPreventivaseCorretivasTotal: (params: DashboardChartParams) =>
    AxiosCharts.get(`${BASE}/horas-preventivas-corretivas-total`, { params, paramsSerializer: serialize }),

  getAnaliseFalhasSDaiPorPeriodo: (params: DashboardChartParams) =>
    AxiosCharts.get(`${BASE}/analise-falhas-sdai-por-periodo`, { params, paramsSerializer: serialize }),

  getEntradaOcorrenciasPorSistemaPeriodo: (params: DashboardChartParams) =>
    AxiosCharts.get(`${BASE}/entrada-ocorrencias-por-sistema-periodo`, { params, paramsSerializer: serialize }),

  getSaidaOcorrenciasPorSistemaPeriodo: (params: DashboardChartParams) =>
    AxiosCharts.get(`${BASE}/saida-ocorrencias-por-sistema-periodo`, { params, paramsSerializer: serialize }),

  // Para componentes que recebem httpPath como prop (ex: OccurrencesRequiredBySystem, SDAIFailuresAnalysisByPeriod)
  getByPath: (path: string, params: DashboardChartParams) =>
    AxiosCharts.get(`${BASE}${path}`, { params, paramsSerializer: serialize }),

  // Horas Técnicas: última atualização e trigger de atualização
  getUltimaAtualizacaoHorasTecnicas: (params: UpdateParamsType) =>
    AxiosCharts.get(`${BASE}/ultima-atualizacao-dm-horas-tecnicas-por-sistema`, {
      params,
      paramsSerializer: serialize,
    }),

  triggerAtualizacaoHorasTecnicas: (params: UpdateParamsType) =>
    AxiosCharts.get(`${BASE}/atualizar-dm-horas-tecnicas-por-sistema`, { params, paramsSerializer: serialize }),
};

export { DashboardChartsService };
